import makeApiCall from "./axiosIndex";
import purchaseOrderApis from "./PurchaseOrder";
const STATIC_FILES_DATA = {
  docKeys: [
    {
      order: 0,
      module: "Purchase Request",
      moduleFileType: "signature.png",
    },
  ],
};

const purchaseRequestApis = {
  purchaseRequestCreation: (data: any) =>
    makeApiCall({
      url: "/purchase-request/new",
      method: "post",
      data,
    }),

  fetchList: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/purchase-request/list`,
    }),
  getById: (prId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/purchase-request/getById`,
      params: { prId },
    }),

  fetchPendingApprovals: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/purchase-request/pendingApprovals`,
    }),
    
  approve: (prId: number, files: File[] = []): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      prId,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("request", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "put",
      url: `/purchase-request/approve`,
      data: formData,
    });
  },

  reject: (prId: number, reason: string, files: File[] = []): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      prId,
      reason,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("request", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "put",
      url: `/purchase-request/reject`,
      data: formData,
    });
  },

  newVersion: (prId: any, data: any) =>
    makeApiCall({
      url: "/purchase-request/newVersion",
      method: "post",
      params: { prId },
      data,
    }),
  convertToRFQ: (prId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/purchase-request/convertToRFQ`,
      params: { prId },
    }),
  convertToPO: (prId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/purchase-request/convertToPO`,
      params: { prId },
    }),
  prTracking: (prId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/purchase-request/prTracking`,
      params: { prId },
    }),
  inactivatePR: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/purchase-request/inactivate`,
      data,
    }),
  fetchPrListPagination: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/purchase-request/paginationList",
      method: "get",
      params,
    }),
  fetchPrPaginationPendingApprovals: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/purchase-request/paginationPendingApprovals",
      method: "get",
      params,
    }),
  fetchPRVersions: (prSequence: string): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/purchase-request/versions`,
      params: { prSequence },
    }),
  materialBulkUploadCreate: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/purchase-request/materialBulkUploadCreate`,
      data,
    }),
};

export default purchaseRequestApis;
